enum ShiftStatus {
  unconfirmed = "未確認",
  verified = "確認済み",
  absence = "当日欠勤",
  tardy = "遅刻",
}

export default ShiftStatus;
